import { render } from "./SFDetailsView.vue?vue&type=template&id=6452fc0e"
import script from "./SFDetailsView.vue?vue&type=script&lang=js"
export * from "./SFDetailsView.vue?vue&type=script&lang=js"

import "./SFDetailsView.vue?vue&type=style&index=0&id=6452fc0e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__